"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Sign in page, reached after the user signs in with MS AD
 */
var react_1 = __importDefault(require("react"));
var js_cookie_1 = __importDefault(require("js-cookie"));
var react_router_dom_1 = require("react-router-dom");
var ApAuthenticationContext_1 = require("../ApAuthenticationContext");
exports.ApSignIn = function () {
    var redirect = js_cookie_1.default.get("redirect");
    if (redirect) {
        js_cookie_1.default.remove("redirect");
        return react_1.default.createElement(react_router_dom_1.Redirect, { to: redirect });
    }
    return react_1.default.createElement(react_router_dom_1.Redirect, { to: "/" });
};
exports.ApRedirectRoute = function (_a) {
    var children = _a.children, routes = _a.routes;
    return (react_1.default.createElement(react_router_dom_1.Switch, null,
        react_1.default.createElement(react_router_dom_1.Route, { path: ApAuthenticationContext_1.REDIRECT_URL, exact: true, component: exports.ApSignIn }),
        routes ? routes() : children));
};
//# sourceMappingURL=ApRedirectRoute.js.map